import { JWT, REFRESH_TOKEN, SHOULD_REDIRECT } from 'constants/system';
import { setJWT, setJWTRefresh } from 'utils/cookies';
import storeVerticalFilters from 'utils/storeVerticalFilters';

/**
 * Log user if jwt exists in param - this is used primarily by SSO
 */
const addJwtInterceptor = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const jwt = urlSearchParams.get(JWT);
  const jwtRefresh = urlSearchParams.get(REFRESH_TOKEN);
  const redirect = urlSearchParams.get(SHOULD_REDIRECT) !== 'False';
  storeVerticalFilters();
  if (jwt) {
    // This will set the jwt token and redirect user to '/'
    setJWT({ value: jwt, redirect });
  }
  if (jwtRefresh) {
    setJWTRefresh({ value: jwtRefresh });
  }
};

export default addJwtInterceptor;
